export const adHocSurveyTypes = {
    Generics: 70,
    FiveMinex: 90,
    AdHocScreener: 95
}

export function GetSurveyTypeName(surveyType) 
{
    switch (surveyType) {
        case adHocSurveyTypes.Generics:
            return "Generics";
        case adHocSurveyTypes.FiveMinex:
            return "5Minex";
        case adHocSurveyTypes.AdHocScreener:
            return "5Minex Screener";
        default:
            throw new Error("Unknown survey type");
    }
}